module.exports = __webpack_public_path__ + "static/img/jhg_detail1.525759e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jhg_detail1.png
// module id = fpjd
// module chunks = 0